import {
  StyleRulesCallback,
  WithStyles,
  withStyles as withStylesCb
} from "@material-ui/core/styles";

export const styles: StyleRulesCallback = ({ palette, spacing: { unit } }) => ({
  container: {
    backgroundColor: palette.error.light,
    color: palette.common.white,
    padding: `${unit * 2}px ${unit * 4}px`
  }
});

export type Styles = WithStyles<typeof styles>;
export const withStyles = withStylesCb(styles);
